export default "__VITE_ASSET__YfdCCLrw__"